import { styled } from 'leva/plugin'

export const Canvas = styled('canvas', {
  cursor: 'crosshair',
  $draggable: '',
})

export const SpringPreview = styled('div', {
  backgroundColor: '$accent2',
  overflow:'clip',
  width: '100%',
  height: '6px',
  opacity: 0.8,
  borderRadius: 1,
  transition: 'opacity 350ms ease',
  transformOrigin: 'left',
})